// src/mobile_pages/contract/Result.jsx


const Result = () => {
  return (
    <div className="mobile-center-wrapper">
      <div className="space-y-4 mb-16">
        {/* 헤더 */}
        <div className="bg-white rounded-lg p-4 border">
          <div className="flex items-center gap-3">
            <div>
              <h2 className="text-lg font-bold text-gray-900">예산 대비 실적</h2>
              <p className="text-gray-500 text-xs mt-0.5">
                예산 집행 현황을 확인합니다
              </p>
            </div>
          </div>
        </div>

        {/* 준비 중 안내 */}
        <div className="bg-white rounded-lg p-8 border text-center">
          <h3 className="text-base font-semibold text-gray-900 mb-2">
            준비 중입니다
          </h3>
          <p className="text-sm text-gray-500 leading-relaxed">
            예산 대비 실적 분석 기능이<br />
            곧 제공될 예정입니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Result;
